import axios from 'axios';
import CSharpUtils from './CSharpUtils';
import U from './Utils';

export interface UploadNotatFileResult {
  success: boolean;
  errorMessage?: string;
}

export async function uploadNotatFileWithEmail(formData: FormData): Promise<UploadNotatFileResult> {
  try {
   /* const dotNetApiUrl = `${U.URL_ADDRESS}${U.WEBAPI_PATH}/notat/UploadNotatFileWithEmail`; */
    const dotNetApiUrl = `${U.URL_ADDRESS}${U.WEBAPI_PATH}/v1/test/varetek/UploadNotatFileWithEmail`;
  //  const dotNetApiUrl = `http://localhost:3500${U.WEBAPI_PATH}/test/mailgun/UploadNotatFileWithEmail`;

   // Debug logging
    console.log('UploadNotat API Debug:');
    console.log('URL_ADDRESS:', U.URL_ADDRESS);
    console.log('WEBAPI_PATH:', U.WEBAPI_PATH);
    console.log('Proxy URL:', dotNetApiUrl);
    //console.log('Search Request:', searchRequest);
    //console.log('Token:', CSharpUtils.Get_Token);
    //
    const config = {
      method: 'post',
      baseURL: dotNetApiUrl,
      data: formData,
      headers: {
        // Don't set Content-Type for FormData - axios will set it automatically with boundary
        Authorization: `Bearer ${CSharpUtils.Get_Token}`,
      },
      timeout: 80000,
      withCredentials: false,
      secure: false,
      changeOrigin: true,
      mode: 'no-cors',
    };

    await axios.request(config);
    return { success: true };
  } catch (error: any) {
    U.error("Upload error:", error);
    U.error("Error response:", error.response);
    U.error("Error response data:", error.response?.data);
    U.error("Error status:", error.response?.status);

    let errorMessage = "Ukjent feil";
    if (error.response?.data) {
      if (typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      } else if (error.response.data.message) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = JSON.stringify(error.response.data);
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    return { success: false, errorMessage };
  }
}
